var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Collapse",
    {
      staticClass: "ShowNotice",
      attrs: {
        id: _vm.id,
        title: _vm.title,
        expand: _vm.expand,
        enableExpandByClickingTitle: true,
      },
      on: { "expand-status": _vm.updateExpand },
    },
    [
      _c(
        "div",
        {
          staticClass: "notice_content",
          attrs: { slot: "content" },
          slot: "content",
        },
        [
          _vm._l(_vm.noticeContent, function (item, index) {
            return [
              _c("ShowNoticeContent", {
                key: "notice_content_" + index,
                attrs: { content: item, deepIndex: 0 },
              }),
            ]
          }),
          _vm._v(" "),
          _vm.noticeContentCN ? _c("div", { staticClass: "cn-hr" }) : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.noticeContentCN, function (item, index) {
            return [
              _c("ShowNoticeContent", {
                key: "cn_hr_" + index,
                attrs: { content: item, deepIndex: 0 },
              }),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }